<template>
    <div class="card flex justify-content-center">
            <ProgressSpinner v-if="loading" class="spinner z-5" style="width: 50px; height: 50px" strokeWidth="8" fill="var(--surface-ground)"
                animationDuration=".5s" aria-label="Custom ProgressSpinner"/>
        </div>

     <Button :disabled="titulo == '' || titulo == null || titulo == 'undefined' " @click="criarFormsNomesTurmas" label="Criar um formulário Google para avaliar o estudante" text />
</template>



<script setup>
import { supabase } from '@/supabase';
import { onMounted, onUnmounted } from 'vue';
import { ref } from 'vue'
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'

import { defineEmits } from 'vue'

const emits = defineEmits(['formIdUpdated'])

const updateFormId = (formId) => {
    emits('formIdUpdated', { idAvaliacao: props.idAvaliacao, formId: formId })
}

const loading = ref(false);

const props =  defineProps({
    titulo: String,
    turmas: Array,
    idAvaliacao: Number
})

// variável do forms api
let isInit = false;
let gisInited = false;
let gapiInited = false;
let tokenClient;


// Função para adicionar o script dinamicamente
const loadScript = (id, src, onLoad) => {
  if (document.getElementById(id)) {
    return; // Script já adicionado
  }
  const script = document.createElement('script');
  script.id = id;
  script.src = src;
  script.async = true;
  script.defer = true;
  script.onload = onLoad;
  document.head.appendChild(script);
};

// Função para remover o script (opcional)
const removeScript = (id) => {
  const script = document.getElementById(id);
  if (script) {
    document.head.removeChild(script);
  }
};

// Funções específicas para carregar e remover os scripts do Google
const loadGoogleScripts = () => {
  loadScript('google-api', 'https://apis.google.com/js/api.js', () => {
    console.log('Google API script carregado');
    gapiLoad()
  });
  loadScript('google-gis', 'https://accounts.google.com/gsi/client', () => {
    console.log('Google Identity Services script carregado');
    gisInit()
  });
};

const unloadGoogleScripts = () => {
  removeScript('google-api');
  removeScript('google-gis');
};

onMounted(() => {
  loadGoogleScripts();
});

onUnmounted(() => {
  unloadGoogleScripts();
});


// funções padrão para incializar o formulário e função de autenticação
function formsAutenticacao() {
    return new Promise((resolve, reject) => {
        tokenClient.callback = (resp) => {
            if (resp.error !== undefined) {
                reject(resp);
            }
            resolve(true);
        }

        if (gapi.client.getToken() === null) {

            tokenClient.requestAccessToken({ prompt: 'consent' });
        } else {
            tokenClient.requestAccessToken({ prompt: '' });
            resolve(true);
        }
    });
}

function checkBeforeStart() {
    if (gapiInited && gisInited) {
        // Start only when both gapi and gis are initialized.
        isInit = true;
    }
}

function gisInit() {

    tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: '758705817118-7miqlg8frcimb74s2kn0utciecf8sls2.apps.googleusercontent.com',
        scope: 'https://www.googleapis.com/auth/drive.file',
        callback: '', 
    });
    gisInited = true;
    checkBeforeStart();
}

function gapiInit() {
    gapi.client.init({
        // NOTE: OAuth2 'scope' and 'client_id' parameters have moved to initTokenClient().
    })
        .then(function () {  // Load the Calendar API discovery document.
            gapi.client.load('https://forms.googleapis.com/$discovery/rest?version=v1');
            gapiInited = true;
            checkBeforeStart();
        });
}

function gapiLoad() {
    gapi.load('client', gapiInit);
}


async function criarFormsNomesTurmas() {
    if(props.idAvaliacao == undefined){
        alert('Primeiro você precisa salvar a avaliação')
        return
    } 
    loading.value = true
    let titulo = props.titulo
    let turmasIds = []
    props.turmas.forEach(turma => turmasIds.push(turma.idDaTurma))
    
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select('idDaTurma, users(id, nome)')
        .in('idDaTurma', turmasIds)
        .order('nome', { ascending: true, foreignTable: 'users' }, )

    let estudantes = []
    data.forEach(item => estudantes.push(item.users.nome))
    estudantes.sort();


    try {
        let authResult = await formsAutenticacao();
        if (authResult) {
            // a autenticação foi bem-sucedida, continue a execução
        }
    } catch (error) {
        // a autenticação falhou, aborte a execução ou manipule o erro
        console.log('A autenticação falhou', error);
        loading.value = false
        return;
    }
    
    
    try {
        const response = await gapi.client.forms.forms.create({
            'info': {
                'title': titulo,
                'documentTitle': titulo
            }
        });
        console.log(response.result)
        let responderUri = response.result.responderUri;
        responderUri = responderUri.replace('https://docs.google.com/forms/d/e/', '');
        responderUri = responderUri.replace('/viewform', '');

        let formId = response.result.formId;
        let estudanteOptions = [];
        let turmasOptions = [];

        for (let estudante of estudantes) {
            estudanteOptions.push({ 'value': estudante });
        };
        let turmas = [] 
        props.turmas.forEach(turma => turmas.push(turma.nome))
        for (let turma of turmas) {
            turmasOptions.push({ 'value': turma });
        }

        console.log(estudanteOptions)
        console.log(turmasOptions)
        console.log(formId)


        const response2 = await gapi.client.forms.forms.batchUpdate({
            'formId': formId,

            'requests': [

                {
                    "createItem": {
                        "item": {
                            'title': 'Qual seu nome?',
                            "questionItem": {
                                "question": {
                                    "required": true,
                                    "choiceQuestion": {
                                        "options": estudanteOptions,
                                        "type": "DROP_DOWN"
                                    }
                                }
                            }
                        },
                        'location': {
                            'index': 0
                        }
                    }
                },
                {
                    "createItem": {
                        "item": {
                            'title': 'Qual sua turma?',
                            "questionItem": {
                                "question": {
                                    "required": true,
                                    "choiceQuestion": {
                                        "options": turmasOptions,
                                        "type": "DROP_DOWN"
                                    }
                                }
                            }
                        },
                        'location': {
                            'index': 1
                        }
                    }
                },
                {
                    "updateSettings": {
                        "settings": {
                            "quizSettings": {
                                "isQuiz": true
                            }
                        },
                        updateMask: "quizSettings.isQuiz",
                    }
                }
            ],
        });
    
        let urlDoFormulario = 'https://docs.google.com/forms/d/' + formId + '/edit';
        
        let questoaComNomes = response2.result.replies[0].createItem.questionId[0];
        let id = formId;
        
        //return `${formId},${questoaComNomes}`;
        let salvar = await salvarIdForms(id, questoaComNomes, responderUri)
        if(!salvar){
            loading.value = false
            alert( 'Ocorreu um erro ao criar o formulário')
            return
        }
        
        updateFormId(formId)
        

        alert('Formulário criado com sucesso!');
        loading.value = false

        window.open(urlDoFormulario, '_blank');



    } catch (error) {
        console.log(error);
    }
}

async function salvarIdForms(formId, questoaComNomes, responderUri){
    const { error } = await supabase
        .from('planos_avaliacoes')
        .update({ forms_id: formId, id_questao_com_nomes: questoaComNomes, responder_uri: responderUri })
        .eq('id', props.idAvaliacao)

    if (error) {
        alert(error.message)
        return false
    }else{
        return true
    }
}


</script>
<style scoped>
.spinner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
Explicação: